import { render, staticRenderFns } from "./TasksDisplay.vue?vue&type=template&id=c0bbf196&"
import script from "./TasksDisplay.vue?vue&type=script&lang=ts&"
export * from "./TasksDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports